import React from 'react';
import PropTypes from 'prop-types';
import params from '../../utils/params';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import HotelIcon from '@material-ui/icons/Hotel';
import CommuteIcon from '@material-ui/icons/Commute';
//import BeenHereIcon from '@material-ui/icons/Beenhere';
import MylocationIcon from '@material-ui/icons/MyLocation';
import LinearProgress from '@material-ui/core/LinearProgress';

import LocationSearchInput from "../utils/LocationSearchInput";
import {ValidatorForm} from "react-material-ui-form-validator";
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ScrollArea from 'react-scrollbar';
import Button from '@material-ui/core/Button';


import CssBaseline from '@material-ui/core/CssBaseline';
import {withStyles} from '@material-ui/core/styles';
import 'react-vertical-timeline-component/style.min.css';
import 'moment/locale/fr';
import DateRange from '../utils/DateRange';
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import Picker from '../utils/Picker'
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from 'moment';

import 'moment/locale/fr';
const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    scrollArea: {
        height: "calc(100vh - 114px)",
    },
    scrollAreaList: {
        height: 200,
    },
    buttonProgress: {
        color: "green",
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -70,
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonCalculate: {

    },
});

moment.locale('fr');

class Journey extends React.Component {

    render() {
        let {calculating, distances} = this.props;
        
        let kilometers = 0;
        distances.forEach(function(d) {
            kilometers += d.distance.value;
        });


        return (
            <React.Fragment>
                <CssBaseline />
                {!this.props.dataLoaded && <LinearProgress />}

                <Grid container spacing={24}>
                    <Grid item xs={4} >
                        <Paper className={this.props.classes.root} elevation={1}>
                            <h3>
                                Résumé du parcours.
                            </h3>
                            <Grid container spacing={24}>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={this.props.startEnd}
                                                onChange={this.props.handleStartEndChange}
                                                value="startEnd"
                                            />
                                        }
                                        label="Ajouter point de départ/arrivée"
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <Typography>Période :</Typography>
                                    <DateRange dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} onChangeDateRange={this.props.onChangeDateRange} format={"DD/MM/YYYY"} dateOnly/>
                                </Grid>
                                <Grid item xs={12} >
                                    <Typography>Détails :</Typography>
                                    <p>{"* " + this.props.steps.filter(step => step.type === "audit").length + " audits et " + this.props.steps.filter(step => step.type === "hotel").length + " étapes d'hébergements"}</p>
                                    <p>{"* " + (kilometers > 0 ? (kilometers/1000) : "?") + " km parcourus" }</p>
                                </Grid>
                                <Grid item xs={12} >
                                    {(this.props.steps.filter(step => step.value.address === "").length > 0) && (
                                        <Typography>Liste des hébergements sans adresse:</Typography>
                                    )}
                                    {(this.props.steps.filter(step => step.value.address === "").length > 0) ? (<ScrollArea
                                        speed={0.8}
                                        className={this.props.classes.scrollAreaList}
                                        contentClassName="content"
                                        horizontal={false}
                                    >
                                        <List component="nav">
                                            {this.props.steps.filter(step => step.type === "hotel" && step.value.address === "").map((step, index) => (
                                                <ListItem button key={index}>
                                                    <ListItemText>
                                                        {(step.value.period === "morning" ? "Matin":"Soirée") + " du " + moment(step.value.date).format("dddd Do MMMM")}
                                                    </ListItemText>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </ScrollArea>) : (
                                        <div className={this.props.classes.wrapper}>
                                            {this.props.dataLoaded && (
                                                <Button
                                                variant="contained"
                                                color="primary"
                                                className={this.props.classes.buttonCalculate}
                                                disabled={(calculating !== 0)}
                                                onClick={this.props.calculateDistance}
                                                >
                                                Calculer les distances
                                                </Button>
                                                )}
                                            {(this.props.dataLoaded && this.props.distances.length > 0) && (
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    className={this.props.classes.buttonCalculate}
                                                    disabled={(calculating !== 0)}
                                                    onClick={this.props.exportDistancesToJson}
                                                >
                                                    Télécharger
                                                </Button>
                                            )}
                                            {calculating > 0 && ( <LinearProgress color="primary" variant="determinate" value={calculating} />)}
                                        </div>
                                    )}
                                </Grid>
                            </Grid>

                        </Paper>
                    </Grid>
                    <Grid item xs={8} >
                        <ScrollArea
                            speed={0.8}
                            className={this.props.classes.scrollArea}
                            contentClassName="content"
                            horizontal={false}
                        >
                            <VerticalTimeline>
                                {this.props.steps.map((step, index) => {
                                        if(step.type === "audit"){
                                            return (
                                                <div style={{marginBottom: 40}} key={index}>
                                                    {(index > 0 && this.props.distances.length === this.props.steps.length - 1 && this.props.distances[index-1].distance.text !== "") && (
                                                        <VerticalTimelineElement
                                                            position={"left"}
                                                            className="vertical-timeline-element--audit"
                                                            iconStyle={{
                                                                display: 'none',
                                                            }}
                                                            icon={<CommuteIcon/>}
                                                        >
                                                            <h3 className="vertical-timeline-element-title">{this.props.distances[index-1].distance.text + ", " + this.props.distances[index-1].duration.text}</h3>
                                                            {(this.props.distances[index-1].path) && (
                                                                <img style={{width: "100%"}} src={"https://maps.googleapis.com/maps/api/staticmap?size=600x400&path=enc:"+this.props.distances[index-1].path+"&key=" + params.GOOGLE_KEY} alt="tracé" />
                                                            )}
                                                        </VerticalTimelineElement>
                                                    )}
                                                    <VerticalTimelineElement
                                                        position={"left"}
                                                        className="vertical-timeline-element--audit"
                                                        date={moment(step.value.date).format("dddd Do MMMM YYYY à H:mm")}
                                                        iconStyle={{
                                                            background: 'rgb(33, 150, 243)',
                                                            color: '#fff'
                                                        }}
                                                        icon={<CommuteIcon/>}
                                                    >
                                                        <h3 className="vertical-timeline-element-title">{step.value.company.name}</h3>
                                                        <h4 className="vertical-timeline-element-subtitle">{step.value.client}</h4>
                                                        <p>
                                                            {step.value.address }
                                                        </p>
                                                    </VerticalTimelineElement>

                                                </div>
                                            )
                                        }else if(step.type === "hotel"){
                                            return (
                                                <div style={{marginBottom: 40}} key={index}>
                                                    {(index > 0 && this.props.distances.length === this.props.steps.length - 1 && this.props.distances[index-1].distance.text !== "") && (
                                                        <VerticalTimelineElement
                                                            position={"left"}
                                                            className="vertical-timeline-element--audit"
                                                            iconStyle={{
                                                                display: 'none',
                                                            }}
                                                            icon={<CommuteIcon/>}
                                                        >
                                                            <h3 className="vertical-timeline-element-title">{this.props.distances[index-1].distance.text + ", " + this.props.distances[index-1].duration.text}</h3>
                                                            {(this.props.distances[index-1].path) && (
                                                                <img style={{width: "100%"}} src={"https://maps.googleapis.com/maps/api/staticmap?size=600x400&path=enc:"+this.props.distances[index-1].path+"&key=" + params.GOOGLE_KEY} alt="tracé" />
                                                            )}

                                                        </VerticalTimelineElement>
                                                    )}
                                                    <VerticalTimelineElement
                                                        key={index}
                                                        position={"right"}
                                                        className="vertical-timeline-element--hotel"
                                                        date={(step.value.period === "morning" ? "Matin":"Soirée") + " du " + moment(step.value.date).format("dddd Do MMMM YYYY")}
                                                        iconStyle={{ background: '#ff9100', color: '#fff' }}
                                                        icon={<HotelIcon />}
                                                    >
                                                        <h3 className="vertical-timeline-element-title">{(step.value.period === "morning" ? "Début":"Fin") + " de journée"}</h3>
                                                        <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form} style={{margin: 0}}>
                                                            <LocationSearchInput label="Adresse" merge={true} address={step.value.address} handleInputChange={(e) => this.props.handleHotelsChange(e, index)} />
                                                        </ValidatorForm>
                                                    </VerticalTimelineElement>
                                                </div>
                                            )
                                        }else{
                                            return (
                                                <VerticalTimelineElement
                                                    key={index}
                                                    position={"right"}
                                                    className="vertical-timeline-element--other"
                                                    iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                                                    icon={<MylocationIcon />}
                                                >
                                                    <h3 className="vertical-timeline-element-title">{(step.type === "start") ? "Départ" : "Arrivée"}</h3>
                                                    <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form} style={{margin: 0}}>
                                                        <LocationSearchInput label="Adresse" merge={true} address={step.value.address} handleInputChange={(e) => this.props.handleHotelsChange(e, index)} />
                                                    </ValidatorForm>
                                                    <MuiPickersUtilsProvider locale="fr" moment={moment} utils={MomentUtils}>
                                                        <ValidatorForm onSubmit={this.props.handleFormSubmit} >
                                                            <Picker
                                                                label="Date d'arrivée"
                                                                onChange={(date) => this.props.handleDateChange(date, index)}
                                                                name="date"
                                                                value={step.value.date}
                                                                format="DD/MM/YYYY HH:mm"
                                                            />
                                                        </ValidatorForm>
                                                    </MuiPickersUtilsProvider>
                                                </VerticalTimelineElement>
                                            )
                                        }

                                    }
                                )}

                                {/*<VerticalTimelineElement
                                    iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                                    icon={<BeenHereIcon />}
                                />*/}
                            </VerticalTimeline>
                        </ScrollArea>

                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

Journey.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Journey);



// WEBPACK FOOTER //
// ./src/component/audit/journey.js